import { render, staticRenderFns } from "./CounterCell.vue?vue&type=template&id=0c53125e"
import script from "./CounterCell.vue?vue&type=script&lang=js"
export * from "./CounterCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports